<template>
    <el-table :data="formatData" :row-style="showRow" :height="tbHeight" v-bind="$attrs">
        <el-table-column v-if="isShowCheckbox" :render-header="renderHeader" width="50" align="center">
            <template slot-scope="scope">
                <el-checkbox v-model="scope.row.checks" @change="toselect(scope.row)"></el-checkbox>
            </template>
        </el-table-column>
        <el-table-column  v-if="isShowOrgTree" label="" width="60" >
            <template slot-scope="scope">
                <el-button v-if="scope.row.isShowOrgTreeBtn" size="mini" class="iconfont icon-other-liucheng" title="百川金字塔" circle @click="handleShowOrgTreeView(scope.row)"></el-button>
            </template>
        </el-table-column>
        <el-table-column v-if="columns.length===0" width="150">
            <template slot-scope="scope">
                <span v-for="space in scope.row._level" :key="space" class="ms-tree-space"/>
                <span v-if="iconShow(0,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
                <i v-if="!scope.row._expanded" class="el-icon-plus"/>
                <i v-else class="el-icon-minus"/>
                </span>
                {{ scope.$index }}
            </template>
        </el-table-column>
        <template v-else v-for="(column, index) in columns" >
            <el-table-column v-if="column.fixed" fixed :show-overflow-tooltip="true" :key="column.value" :label="column.text" :width="column.width">
                <template slot-scope="scope">
                    <!-- Todo -->
                    <!-- eslint-disable-next-line vue/no-confusing-v-for-v-if -->
                    <span v-for="space in scope.row._level" v-if="index === 0" :key="space" class="ms-tree-space"/>
                    <span v-if="iconShow(index,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
                        <i v-if="!scope.row._expanded" class="el-icon-plus"/>
                        <i v-else class="el-icon-minus"/>
                    </span>
                    <template v-if="scope.row.dir&&column.value==='label'" >
                        <el-button icon="el-icon-message" plain> {{ scope.row[column.value] }}</el-button>
                    </template>
                    <template v-else >
                        <!-- <span><a href="#"> {{ scope.row[column.value] }}</a></span> -->
                        <template v-if="column.isTag" >
                            <el-tag  :type="column.tagList[scope.row[column.value]].view" size="small">{{ column.tagList[scope.row[column.value]].label }}</el-tag>
                        </template>
                        <template v-else >
                            <span style="cursor:pointer;">{{ scope.row[column.value] }}</span>
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column v-else :show-overflow-tooltip="true" :key="column.value" :label="column.text" :width="column.width">
                <template slot-scope="scope">
                    <!-- Todo -->
                    <!-- eslint-disable-next-line vue/no-confusing-v-for-v-if -->
                    <span v-for="space in scope.row._level" v-if="index === 0" :key="space" class="ms-tree-space"/>
                    <span v-if="iconShow(index,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
                    <i v-if="!scope.row._expanded" class="el-icon-plus"/>
                    <i v-else class="el-icon-minus"/>
                    </span>
                    <template v-if="scope.row.dir&&column.value==='label'" >
                    <el-button icon="el-icon-message" plain> {{ scope.row[column.value] }}</el-button>
                    </template>
                    <template v-else >
                    <!-- <span><a href="#"> {{ scope.row[column.value] }}</a></span> -->
                    <template v-if="column.isTag" >
                        <el-tag  :type="column.tagList[scope.row[column.value]].view" size="small">{{ column.tagList[scope.row[column.value]].label }}</el-tag>
                    </template>
                    <template v-else >
                        <span style="cursor:pointer;">{{ scope.row[column.value] }}</span>
                    </template>
                    </template>
                </template>
            </el-table-column>
        </template>

        <!-- fixed="right" -->
        <el-table-column fixed="right" v-if="isShowBtn" label="操作" width="260" >
            <template slot-scope="scope">
                <template v-if="isApply" >
                    <el-button v-if="scope.row.dir&&(scope.row.approvalStatus===0 || scope.row.approvalStatus===3)" type="warning" size="mini" icon="el-icon-star-on"  @click.stop="handleApplyFiles(scope.row)">归档申请</el-button>
                    <el-button v-if="!scope.row.dir&&(scope.row.approvalStatus===0 || scope.row.approvalStatus===3)" type="primary" size="mini" icon="el-icon-edit-outline"  @click.stop="handleOpenFolder(scope.row)">修改</el-button>
                    <el-button v-if="!scope.row.dir&&(scope.row.approvalStatus===0 || scope.row.approvalStatus===3)" type="danger" size="mini" icon="el-icon-delete"  @click.stop="handleDelete(scope.row)">删除</el-button>
                </template>
                <template v-else>
                    <template v-if="scope.row.dir" >
                        <el-button v-permission="permission.archiveApprovalBtn" v-if="scope.row.approvalStatus>=1" style="float:left;height:28px;" type="info" size="mini" icon="el-icon-info" title="审核" circle @click.stop="handleApprovalFiles(scope.row)"></el-button>
                        <el-button v-permission="permission.archiveModifiedBtn" style="float:left;height:28px;" type="primary" size="mini" icon="el-icon-edit-outline" title="修改" circle @click="handleOpenFolder(scope.row)"></el-button>
                        <el-button style="float:left;height:28px;" type="primary" size="mini" icon="el-icon-download" title="打包下载" circle @click.stop="handleFolderDownLoad(scope.row)"></el-button>
                        <ProcessFiles style="float:left;height:28px;margin-left:10px" bizType="archiveInstance" :treeId="scope.row.id+''" :isIconUploadBtn="true" :treeName="scope.row.label" :processInstanceId="processInstanceId" :templateId="templateId" :isApprovalMode="isApprovalMode" @getFileList="getFileList"/>
                    </template>
                    <template v-else>
                        <el-button type="primary" size="mini" icon="el-icon-download" title="下载" circle @click.stop="handleDownLoad(scope.row)"></el-button>
                        <el-button v-permission="permission.archiveModifiedBtn" type="primary" size="mini" icon="el-icon-edit-outline" title="修改" circle @click="handleOpenFolder(scope.row)"></el-button>
                        <!-- <el-button type="danger" v-if="scope.row.showDeleteBtn" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDelete(scope.row)"></el-button> -->
                        <el-button v-permission="permission.archiveDeleteBtn" type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDelete(scope.row)"></el-button>
                        <el-button type="success" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row)"></el-button>
                    </template>
                </template>

            </template>
        </el-table-column>
        <el-table-column fixed="right" v-if="isShowProcessDetail" label="详情" width="60" >
            <template slot-scope="scope">
                <el-button v-if="scope.row.nodeType===0||scope.row.nodeType===1" size="mini" icon="el-icon-view" title="流程详情" circle @click="checkProcessDetail(scope.row)"></el-button>
            </template>
        </el-table-column>
        <slot/>
    </el-table>
</template>

<script>
    'use strict';
    import treeToArray from './eval';
    import ProcessFiles from '@/pages/process/components/ProcessFiles';
    import { cloneDeep } from 'lodash';
    import { CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN,
        CONST_DOCUMENT_ARCHIVE_MODIFIED_BTN,
        CONST_DOCUMENT_ARCHIVE_DELETE_BTN
    } from '@/common/constants';
    export default {
        name: 'TreeTable',
        components: {
            ProcessFiles
        },
        data () {
            return {
                // chooseson: true, //全选
                // key: true //单个点击直到全部选中
                permission: {
                    archiveApprovalBtn: [// 业务档案文件审核
                        CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN
                    ],
                    archiveModifiedBtn: [// 业务档案文件修改
                        CONST_DOCUMENT_ARCHIVE_MODIFIED_BTN
                    ],
                    archiveDeleteBtn: [// 业务档案文件删除
                        CONST_DOCUMENT_ARCHIVE_DELETE_BTN
                    ]
                }
            };
        },
        created () {
            // console.log('====' + this.permission.archiveApprovalBtn);
            // console.log('====' + this.permission.archiveModifiedBtn);
            // console.log('====' + this.permission.archiveDeleteBtn);
        },
        props: {
            /* eslint-disable */
            data: {
                type: [ Array, Object ],
                required: true
            },
            columns: {
                type: Array,
                default: () => []
            },
            evalFunc: Function,
            evalArgs: Array,
            expandAll: {
                type: Boolean,
                default: false
            },
            isShowCheckbox:{
              type: Boolean,
              default: true
            },
            eltreeid:{
              type: String,
              default: "eltreeid"
            },
            isShowBtn:{
              type: Boolean,
              default: false
            },
            treeId:{
               type: String,
            },
            treeName: {
                type: String
            },
            processInstanceId: {
                type: String
            },
            templateId:{
              type: String
            },
            tableStyle:{
              type: String,
              default: "min-height:450px;"
            },
            tbHeight:{
              type: String,
              default: "100%"
            },
            isApply:{//是否申请人模式
              type: Boolean,
              default: false
            },
            isShowProcessDetail:{//是否显示流程详情
              type: Boolean,
              default: false
            },
            isShowOrgTree:{
              type: Boolean,
              default: false
            },
            isApprovalMode: {// 审核模式
                type: Boolean,
                default: false
            }
        },
        computed: {
            // 格式化数据源
            formatData: function() {
                let tmp;
                if (!Array.isArray(this.data)) {
                    tmp = [this.data];
                } else {
                    tmp = this.data;
                }
                const func = this.evalFunc || treeToArray;
                const args = this.evalArgs ? Array.concat([tmp, this.expandAll], this.evalArgs) : [tmp, this.expandAll];
                return func.apply(null, args);
            }
        },
        methods: {
            showRow: function(row) {
                const show = (row.row.parent ? (row.row.parent._expanded && row.row.parent._show) : true)
                row.row._show = show
                return show ? 'animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;' : 'display:none;'
            },
            // 切换下级是否展开
            toggleExpanded: function(trIndex) {
                const record = this.formatData[trIndex]
                record._expanded = !record._expanded
            },
            // 图标显示
            iconShow(index, record) {
                return (index === 0 && record.children && record.children.length > 0)
            },
             //设置表头全选
            renderHeader(h, data) {
                return h("span", [
                    h("input", {
                    attrs: {
                        id:this.eltreeid,
                        type: "checkbox",
                        style:
                        "border: 1px solid #dcdfe6;border-radius: 2px;box-sizing: border-box;width: 14px;height: 14px;background-color: #fff;"
                    },
                    on: {
                            click: () => {
                                //console.log("=============");
                                this.isallcheckedFun();
                            }
                        }
                    })
                ]);
            },
             //功能函数:选中部分子集
            setchildtobeselect(arr, key) {
                arr.forEach((v, i) => {
                    v._expanded = false;//先初始化为闭合,防止上次的已经是打开的状态
                    v.checks = key;
                    v._expanded = key;//选中后展开子项
                    if (v.children) {
                        this.setchildtobeselect(v.children, v.checks);
                    }
                });
            },
            //是否所有的都被选中
            isallchecked(arr) {
                arr.forEach((v, i) => {
                    if (!v.checks) {
                    this.key = false;
                    }
                    if (v.children) {
                    this.isallchecked(v.children);
                    }
                });
            },
            initchecked(){//初始化复选框状态，提供给父组件调用
                var that = this;
                that.isallcheckedFun(that.formatData);
            },
            //设置父级为 未选中状态（父级的父级没改变-有bug）
            setparentfalse(arr, id, level) {
                arr.forEach((v, i) => {
                    if (v._level == level - 1 && v.children) {
                    v.children.forEach((val, ind) => {
                        if (val.id == id) {
                        v.checks = false;
                        return false; //终止此次循环，减少循环次数
                        }
                    });
                    }
                    if (v.children) {
                    this.setparentfalse(v.children, id, level);
                    }
                });
            },
            //设置父级为 选中状态
            setparenttrue(arr, id, level) {
                arr.forEach((v, i) => {
                    if (v._level == level - 1 && v.children) {
                    let key = true;
                    let sameidkey = false;
                    v.children.forEach((val, ind) => {
                        if (val.id == id) {
                        //确保当前点击的在该父级内
                        sameidkey = true;
                        }
                        if (!val.checks) {
                        key = false;
                        }
                    });
                    if (key && sameidkey) {
                        v.checks = true;
                    }
                    }
                    if (v.children) {
                    this.setparentfalse(v.children, id, level);
                    }
                });
            },
            //某个复选框被点击时
            toselect(row) {
                // console.log(row);
                row._expanded = row.checks;//选中后是否展开
                //1、若有子集先让子选中
                if (row.children) {
                    this.setchildtobeselect(row.children, row.checks);
                }
                //2、然后判断是否全选中
                this.key = true; //重置为true，防止上次已经是false的状态
                this.isallchecked(this.formatData);
                //3、设置多选框的状态
                if (!row.checks) {
                    this.setparentfalse(this.formatData, row.id, row._level); //设置父级选中的状态为false
                    document.getElementById(this.eltreeid).checked = false; //设置全选框的状态
                } else {
                    this.setparenttrue(this.formatData, row.id, row._level); //设置父级选中的状态为true
                }
                if (this.key) {
                    document.getElementById(this.eltreeid).checked = true; //设置全选框的状态
                }
            },
            //表头复选框点击触发事件
            isallcheckedFun(){
                var that = this;
                const all = document.getElementById(this.eltreeid);
                if(this.isShowCheckbox){
                    if (all.checked == true) {
                      that.setchildtobeselect(that.formatData, true);
                    } else {
                      that.setchildtobeselect(that.formatData, false);
                    }
                }
            },
            handleOpenFolder(row){
              // console.log(row);
              this.$emit('manageFolder', row);
            },
            getFileList(){
              this.$emit('getFileList');
            },
            handleDownLoad(row){//下载
              this.$emit('handleDownLoad',row);
            },
            handleFolderDownLoad(row){//文件夹下载
              this.$emit('handleFolderDownLoad',row);
            },
            previewFile(file){
              let transferObj= cloneDeep(file);//更改id为文件id
              transferObj.id=transferObj.fileId;
              this.$emit('previewFile',transferObj);
            },
            handleDelete(file){//删除
              let transferObj= cloneDeep(file);//更改id为文件id
              transferObj.id=transferObj.fileId;
              this.$emit('handleDelete',transferObj);
            },
            handleApplyFiles(row){
              this.$emit('handleApplyFiles',row);
            },
            handleApprovalFiles(row){
              this.$emit('handleApprovalFiles',row);
            },
            checkProcessDetail(row){
              this.$emit('checkProcessDetail',row);
            },
            async handleShowOrgTreeView (row) {
               this.$emit('showOrgTreeView',row);
            }
        },
        mounted() {
            /*this.$nextTick(() => {
                var that = this;
                const all = document.getElementById(this.eltreeid);
                if(this.isShowCheckbox){
                  all.onchange = function(e) {
                      // console.log(all.checked);
                      if (all.checked == true) {
                      that.setchildtobeselect(that.formatData, true);
                      } else {
                      that.setchildtobeselect(that.formatData, false);
                      }
                  };
                }

            });*/
        }
    }
</script>
<style rel="stylesheet/css">
    @keyframes treeTableShow {
        from {opacity: 0;}
        to {opacity: 1;}
    }
    @-webkit-keyframes treeTableShow {
        from {opacity: 0;}
        to {opacity: 1;}
    }
</style>

<style lang="less" rel="stylesheet/less">
    @color-blue: #2196F3;
    @space-width: 18px;
    .ms-tree-space {
        position: relative;
        top: 1px;
        display: inline-block;
        font-style: normal;
        font-weight: 400;
        line-height: 1;
        width: @space-width;
        height: 14px;
        &::before {
            content: ""
        }
    }
    .processContainer{
        width: 100%;
        height: 100%;
    }
    table td {
        line-height: 26px;
    }

    .tree-ctrl{
        position: relative;
        cursor: pointer;
        color: @color-blue;
        margin-left: -@space-width;
    }
    .el-table:before {
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/TreeTable/index.vue